import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AirplaneTakeoff } from "../../../../chunks/AirplaneTakeoff.js";
import { H as HumanMaleBoard, N as NotebookCheckOutline, A as AccountSupervisor, B as BookEducation, S as School, a as AccountTieHat } from "../../../../chunks/School.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
import { S as StdHeading } from "../../../../chunks/Button.js";
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".sections_wrapper.svelte-14a4fih{padding:50px 0;display:flex;flex-direction:column;align-items:center;gap:70px;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-14a4fih{padding:25px 5px}}",
  map: null
};
let hero_image = "/instructors.webp";
let background_center = true;
let h1 = "Flight Instructor Program";
let hero_paragraph_content = "Our CFI course enables you to instruct and mentor aspiring pilots while gaining excellent experience as PIC and accumulating flight hours, paving the way for furthering career opportunities. Certified flight instructor jobs include teaching FAA PPL and CPL.";
let pricingPackage = false;
let professionalProgram = false;
let second_center_img_seperating_section = false;
let prerequisites = false;
let programs = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "CFI Training",
        icon: HumanMaleBoard
      },
      {
        text: "CFI Checkride",
        icon: NotebookCheckOutline
      },
      {
        text: "Start Instructing Students",
        icon: AccountSupervisor
      },
      { text: "CFII Course", icon: BookEducation }
    ],
    [
      {
        text: "CFII Checkride",
        icon: AirplaneTakeoff
      },
      { text: "MEI Course", icon: School },
      {
        text: "MEI Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "1500 Hours Start your career",
        icon: AccountTieHat
      }
    ]
  ];
  let center_img_seperating_section = {
    src: "/maverick_teaching.webp",
    alt: "First Landings flight instructor teaching student"
  };
  let faqs = [
    {
      question: "What is cfi?",
      answer: "A Certified Flight Instructor (CFI) is a pilot who has met the necessary qualifications and holds a CFI certificate, which allows them to provide flight instruction to student pilots. CFIs play a crucial role in training and mentoring aspiring pilots, helping them gain the skills and knowledge required to become safe and competent aviators.",
      opened: false
    }
  ];
  $$result.css.add(css);
  return `${$$result.head += `<!-- HEAD_svelte-12swrbj_START -->${$$result.title = `<title>Flight Instructor | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation flight instructor training"><!-- HEAD_svelte-12swrbj_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      programs,
      faqs,
      pricingPackage,
      professionalProgram,
      hero_image,
      background_center,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      second_center_img_seperating_section,
      prerequisites
    },
    {},
    {
      two: () => {
        return `<div slot="two">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1nlm994">A check-ride is an essential part of the pilot certification process
        that includes both a flight test and an oral exam. During a check-ride,
        a designated pilot examiner (DPE) assesses the pilot&#39;s ability to
        operate an aircraft safely and proficiently. The examination covers
        various aspects, including flight maneuvers, navigation, emergency
        procedures, communication skills, and a thorough understanding of
        aviation regulations.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-5aur3t">Checkride Information</div>`;
          }
        })}</div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(StdHeading, "StdHeading").$$render(
          $$result,
          {
            font_family: "Inter",
            color: "dark",
            size: "small"
          },
          {},
          {
            default: () => {
              return `Certified Flight Instructor`;
            }
          }
        )}  <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/instructor_ingress.webp",
            alt: "First Landings instructor piper pilot 100i"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-ktas2c">This CFI course is designed to take a Commercial Pilot single or multi
          engine airplane certificate holder to the completion of the Certified
          Flight Instructor (CFI) Certificate.
          <br> <br>
          Most professional pilots and airline pilots have spent their time as flight
          instructors. There really is no other better option than being a flight
          instructor to gain all that experience and flight time necessary to advance
          on to the other professional pilot careers.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
            }
          }
        )}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1m062ha">A current FAA Commercial Pilot certificate (or ATP) with Airplane
          Category (ASEL or AMEL).
          <br> <br>
          A minimum of class III medical certificate, valid. Basic Med is acceptable.
          <br> <br>
          FIA and FOI exam passed (preferred, but not required), or Ground Instructor
          in lieu of FOI.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1o2jt7g">Prerequisites</div>`;
          }
        })}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1lkb8bt">Our CFI initial course is a very detailed, thorough, and hands-on
          course, and requires a lot of hard work and time on the part of the
          applicant as well as the instructors. The course is about 10-12 hours
          of flight training, and 60-80 hours of ground school. You need to keep
          in mind that this training is about being able to teach aviation, both
          on the ground and in flight. This course is not about your piloting
          skills. We understand that you already hold at least a commercial
          pilot certificate, hence you already have mastered the art of flying.
          Now it is about mastering the art of teaching aviation.
          <br> <br>
          The 60+ hours of the ground school includes all the subject areas covered
          in the Fundamentals of Instruction and the Flight Instructor Aeronautical
          Knowledge. You will have to spend a lot of time yourself for self-study,
          and also practice teaching other students while your instructor is supervising.
          By the time you are ready for your FAA checkride you will have gained all
          the knowledge and confidence necessary to qualify as a flight instructor
          and teach others how to fly.
          <br> <br>
          The Flight portion of the course includes all the Private, Commercial,
          and CFI maneuvers, with you teaching from the right seat. The course also
          includes the required spin awareness, entry, and recovery techniques. At
          the completion of the course, you will have all the skills and confidence
          necessary to teach another pilot while sitting in the right seat of an
          airplane.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-11sjleb">Course Structure</div>`;
          }
        })}</div>  <div style="padding-top: 50px;">${validate_component(StdHeading, "StdHeading").$$render(
          $$result,
          {
            font_family: "Inter",
            color: "dark",
            size: "small"
          },
          {},
          {
            default: () => {
              return `Certified Flight Instructor Instrument`;
            }
          }
        )}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/eb.webp",
            alt: "First Landings instructor"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-trrmfr">This is an add on course to an existing Flight Instructor certificate.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
            }
          }
        )}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1r99k0x">A current FAA Certificated Flight Instructor certificate with Airplane
          Category (ASE or AME).
          <br> <br>
          A minimum of class III medical certificate, valid. Basic Med is acceptable.
          <br> <br>
          FII written exam passed (preferred, but not required).</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1o2jt7g">Prerequisites</div>`;
          }
        })}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1oonfyi">Our CFII add on course is pretty straight forward – we will train you
          and get you ready for the Flight Instructor Instrument Airplane
          practical test.
          <br> <br>
          Ground and Flight Instruction is provided by qualified and experienced
          instructors. Lesson plans and reference materials is included in the ground
          portion of this course.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-11sjleb">Course Structure</div>`;
          }
        })}</div>  <div style="padding-top: 50px;">${validate_component(StdHeading, "StdHeading").$$render(
          $$result,
          {
            font_family: "Inter",
            color: "dark",
            size: "small"
          },
          {},
          {
            default: () => {
              return `Multi Engine Instructor`;
            }
          }
        )}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/neo.webp",
            alt: "First Landings multi engine instructor"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-19zuliu">This MEI course is a training course to help you add Multi Engine
          Rating on your existing FAA Flight Instructor certificate. You must
          have 10 hours PIC in a multi-engine airplane at the time of starting
          this course. If not, please add extra day for each 5 hours missing.
          <br> <br>
          Checkride is scheduled and completed on the 4th day. Our MEI course is
          3 days of ground and flight training and immediately followed by a checkride
          with a DPE on the 4th day. Checkrides are pre-scheduled.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
            }
          }
        )}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-146duq5">A current or expired FAA Flight Instructor certificate (CFI).
          <br> <br>
          A minimum of class III medical certificate, valid. Basic Med is acceptable.
          <br> <br>
          There is no written exam for this add-on course.
          <br> <br>
          10 hours PIC in multi-engine aircraft.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1o2jt7g">Prerequisites</div>`;
          }
        })}</div> <div class="sections_wrapper svelte-14a4fih">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-p57l3c">Our MEI add-on course includes about 10 hours of ground training and
          about 5 hours of flight training covering the multi-engine course
          materials.
          <br> <br>
          Lesson plans are provided as part of the ground school. You will have 2
          ground sessions and 1-2 flight training sessions per day.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-11sjleb">Course Structure</div>`;
          }
        })}</div></div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
